// External Dependencies
import React, { forwardRef } from 'react';
import { DisplayAggregateQuestionDto } from '@keyops-cep/api-client';

// Internal Dependencies
import { ISurveySparrowAnswerData } from '../../../pages/EngagementDetails/types';
import { isNumericChoices } from '../../../utils/functions/visualization-utils';
import { VisualizationChartRef } from '..';

import MultiSelectNumericGrid from './MultiSelectNumericGrid';
import MultiSelectPieMatrix from './MultiSelectPieMatrix';

type MultiSelectGridProps = {
  question: DisplayAggregateQuestionDto;
  questionAnswers: (ISurveySparrowAnswerData | undefined)[];
};

const MultiSelectGrid = forwardRef<VisualizationChartRef, MultiSelectGridProps>(
  ({ question, questionAnswers }, ref) => {
    return isNumericChoices(question.choices) ? (
      <MultiSelectNumericGrid
        ref={ref}
        question={question}
        questionAnswers={questionAnswers}
      />
    ) : (
      <MultiSelectPieMatrix
        ref={ref}
        question={question}
        questionAnswers={questionAnswers}
      />
    );
  }
);

MultiSelectGrid.displayName = 'MultiSelectGrid';

export default MultiSelectGrid;
